export default "__VITE_ASSET__DkxX$SFx__"